<template>
  <div class="yk-custom-daterange-container">
    <div class="wrap" style="display: flex">
      <div class="type" style="display: flex">
        <div :class="{item: true, active: activeTimeType === 0}" @click="activeTimeType = 0">今天</div>
        <div :class="{item: true, active: activeTimeType === 1}" @click="activeTimeType = 1">近7天</div>
        <div :class="{item: true, active: activeTimeType === 2}" @click="activeTimeType = 2">近30天</div>
      </div>
      <el-date-picker
      size="small"
        v-model="dateRange"
        :picker-options="pickerOptions"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :clearable='false'
        @change="changeTime"
        align="right">
      </el-date-picker>
    </div>
  </div>
</template>
<script>
import {
  getTodayStartTimestamp, getTodayEndTimestamp, getSevenTimestamp, getThirtyTimestamp,
} from '@/utils/index';

export default {
  props: {
    type: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      dateRange: [],
      activeTimeType: this.type,
      pickerOptions: {
        disabledDate(time) {
          // 日期只能选择100天前到今天的日期
          const curDate = (new Date()).getTime();
          const three = 100 * 24 * 3600 * 1000;
          const threeMonths = curDate - three;
          return time.getTime() > Date.now() || time.getTime() < threeMonths;
        },
      },
    };
  },
  watch: {
    type(newType) {
      this.changeDateRange(newType);
    },
    dateRange(newV) {
      let selectedDateArr = [];
      if (!newV) {
        selectedDateArr = [];
      } else {
        selectedDateArr = newV;
      }
      this.$emit('change', selectedDateArr);
    },
    activeTimeType(type) {
      this.changeDateRange(type);
      // 需要在change事件之后执行
      this.$nextTick(() => {
        this.$emit('typeChange');
      });
    },
  },
  methods: {
    changeDateRange(type) {
      if (type === 0) {
        this.dateRange = [
          getTodayStartTimestamp(),
          getTodayEndTimestamp(),
        ];
      } else if (type === 1) {
        this.dateRange = [
          getSevenTimestamp(),
          getTodayEndTimestamp(),
        ];
      } else if (type === 2) {
        this.dateRange = [
          getThirtyTimestamp(),
          getTodayEndTimestamp(),
        ];
      }
    },
    changeTime() {
      this.activeTimeType = -1;
    },
  },
  created() {
    this.changeDateRange(0);
  },
};
</script>
<style lang="scss">
.yk-custom-daterange-container {
  > .wrap {
    > .type {
      .item {
        width: 100px;
        min-width: 100px;
        margin-right: 14px;
        flex: 1;
        height: 32px;
        line-height: 32px;
        text-align: center;
        cursor: pointer;
        font-size: 14px;
        border: 1px solid #DFDFDF;
        &.active {
          border: 1px solid #FF9600;
        }
      }
    }
    .el-range-separator {
      width: 40px;
    }
  }
}
</style>
